import classes from './TableRow.module.css';

const Row = (props) => {
  const className = `${classes.tr} ${props.className}`;
  return <div className={className}>{props.children}</div>;
};

export default Row;
